import React from 'react';
// import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import './index.css';
import { Form, Input, Button, Modal } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';

import { useHistory } from 'react-router-dom';

import * as config from "./config";
import UserProfile from './UserProfile';


function success(value, props) {
  // console.log("success.value===", value.info)
  // console.log("success.props.login===", props.login)
  if (value.status === 'success') {
    // console.log("success.status===", 'success')
    UserProfile.setUserdata(value.info);

    let secondsToGo = 3;
    const onOkModal = () => {
      props.login()
    }
    const modal = Modal.success({
      title: value.status,
      content: value.message,
      okText: 'OK',
      onOk: () => {
        onOkModal()
      },
    });
    const timer = setInterval(() => {
      secondsToGo -= 1;
    }, 1000);
    setTimeout(() => {
      clearInterval(timer);
      modal.destroy();
      props.login()
    }, secondsToGo * 1000);
  } else {
    // console.log("success.status===", 'fail')
    let secondsToGo = 3;
    const onOkModal = () => {
    }
    const modal = Modal.error({
      title: value.status,
      content: value.message,
      okText: 'OK',
      onOk: () => {
        onOkModal()
      },
    });

    const timer = setInterval(() => {
      secondsToGo -= 1;
    }, 1000);
    setTimeout(() => {
      clearInterval(timer);
      modal.destroy();
    }, secondsToGo * 1000);
  }

}
const LoginForm = (props) => {
  const history = useHistory();
  const loginAPI = ((values) => {
    // console.log("props===", props)
    let data = {
      "username": values.username,
      "password": values.password
    };
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        "username": values.username,
        "password": values.password
      })
    };

    fetch(config.urlAPI + '/login', requestOptions)
      .then(response => response.json())
      .then(data => {
        // console.log('datammmmm', data)
        if (data) {
          success(data, props)
        }
      })
      .catch(err => {
        console.log("res===", err)
      })
  })

  const onFinish = values => {
    // console.log('Received values of form: ', values);
    loginAPI(values)

    // history.push('/track')
    // window.location.reload();


  };

  const dd = () => {
    console.log('dd');

  }
  return (
    <div className="login-div">
      <Form
        size="large"
        name="normal_login"
        className="login-form"
        initialValues={{
          remember: true,
        }}
        onFinish={onFinish}
      >
        {/* <Button onClick={dd}>dd</Button> */}

        <div className="login-form-logo">
          {/* <Row>
          <Col span={4}> */}
          <img alt="logo" className="" src="../storage/imgs/Trading.jpg" />
          {/* </Col>
          <Col span={20}> */}
          <h1 className="login-form-logo-title">Loxtrade SAMS</h1>
          {/* </Col>
        </Row> */}
        </div>
        <Form.Item
          name="username"
          rules={[
            {
              required: true,
              message: 'Please input your Username!',
            },
          ]}
        >
          <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder="Username" />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[
            {
              required: true,
              message: 'Please input your Password!',
            },
          ]}
        >
          <Input.Password
            prefix={<LockOutlined className="site-form-item-icon" />}
            type="password"
            placeholder="Password"
          />
        </Form.Item>
        {/* <Form.Item>
          <a className="login-form-forgot" href="www.google.com">
            Forgot password
          </a>
        </Form.Item> */}

        <Form.Item>
          <Button type="primary" htmlType="submit" className="login-form-button">
            Log in
          </Button>
          {/* Or <a href="">register now!</a> */}
        </Form.Item>
      </Form>
    </div>

    // </div>
  );
};
export default LoginForm